import MainPageTitle from '@/components/MainPageTitle';
import { Button } from '@mui/material';
import { Add as CreateIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import SchoolsOverview from './SchoolsOverview';
import AppTitle from '@/components/AppTitle';

const SchoolManager = () => (
  <>
    <AppTitle>Schools</AppTitle>
    <MainPageTitle>
      Schools
      <Button
        variant="contained"
        startIcon={<CreateIcon />}
        disableElevation
        component={Link}
        to="/schools/create"
      >
        Create school
      </Button>
    </MainPageTitle>
    <SchoolsOverview />
  </>
);

export default SchoolManager;
